/**
 * RecentContactsPanel — die fünf zuletzt angelegten Kontakte.
 */
import { Link } from 'react-router-dom';
import StatusBadge from '@/components/ui/StatusBadge';
import { createPageUrl } from '@/utils';
import { Panel, PanelSkeleton } from './Panel';

export default function RecentContactsPanel({ loading, leads }) {
  return (
    <Panel overline="Zuletzt angelegt" title="Neueste Kontakte" bodyClassName="px-0 pb-2">
      {loading ? (
        <div className="px-4 sm:px-5 pb-3"><PanelSkeleton rows={4} /></div>
      ) : (
        <ul className="divide-y divide-slate-100 border-t border-slate-100">
          {leads.map((lead) => (
            <li key={lead.id}>
              <Link
                to={createPageUrl('AdminLeads')}
                className="flex items-center justify-between gap-3 px-4 sm:px-5 py-2.5 min-h-[44px] hover:bg-slate-50 transition-colors"
              >
                <span className="min-w-0">
                  <span className="block text-sm font-medium text-slate-900 truncate">{lead.name}</span>
                  {lead.branche && <span className="block text-xs text-slate-500 truncate">{lead.branche}</span>}
                </span>
                <StatusBadge status={lead.status} type="lead" />
              </Link>
            </li>
          ))}
          {leads.length === 0 && <li className="px-4 sm:px-5 py-4 text-sm text-slate-400">Noch keine Kontakte.</li>}
        </ul>
      )}
    </Panel>
  );
}
